// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__2iH_C","filesListContainer":"PosDisputesFiles_filesListContainer__2jOps","filesButton":"PosDisputesFiles_filesButton__3x9FW"};